<template>
  <div>

    <vs-breadcrumb
      class="mb-6"
      :items="
      [
        {
          title: '推单管理',
          url: '/tax/list'
        },
        {
          title: '代扣税率设置',
          active: true
        }
      ]"
    ></vs-breadcrumb>

    <div class="mb-6">
      <vs-button
        class="mr-1"
        @click="add"
      >添加税率</vs-button>
    </div>

    <vs-table
      ref="table"
      :notSpacer="false"
      :stripe="true"
      :max-items="itemsPerPage"
      :data="list"
      :noDataText="noDataText"
    >
      <template slot="thead">
        <vs-th width="4%">编号</vs-th>
        <vs-th width="20%">
          税率名称
        </vs-th>
        <vs-th width="50%">税率（%）</vs-th>

        <vs-th>操作</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              <p>{{tr.id}}</p>
            </vs-td>
            <vs-td>
              <p>{{tr.name}}</p>
            </vs-td>
            <vs-td>
              <p>{{tr.tax_rate}}</p>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <div>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current a-hover"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current a-hover"
                  class="ml-2"
                  @click.stop="deleteData(tr.id)"
                />
              </div>

            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      class="mt-6"
      :total="totalPage"
      v-model="currentx"
      @input="gotoCurrentPage"
    ></vs-pagination>

    <tax-detail ref="tax_dom" @getReBackList="getReBack"></tax-detail>

    <vs-popup
      title="删除此税率设置"
      :active.sync="delPopUpActive"
    >
      <div class>
        <div class="mb-4">是否确认删除？ </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              class="mr-3"
              @click="delConfirm"
              :disabled="btnDisabled"
            >确认删除</vs-button>
            <vs-button
              type="border"
              @click="closeDel"
              :disabled="btnDisabled"
            >关闭</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import taxRepo from '@/repo/tax'
import TaxDetail from './TheTaxDetailDialog.vue'
export default {
  data() {
    return {
      noDataText: '',
      list: [],
      page: 1,
      itemsPerPage: 10,
      totalPage: 0,
      currentx: 1,
      tr_id: null,
      delPopUpActive: false,
      btnDisabled: false,
    }
  },

  components: {
    'tax-detail': TaxDetail,
  },

  created() {
    this.getListData()
  },

  methods: {
    getListData: function () {
      this.$vs.loading()
      const page = this.page
      const per_page = this.itemsPerPage
      let that = this
      taxRepo.list(page, per_page, (error, resp) => {
        that.$vs.loading.close()
        if (resp.code == 0) {
          that.list = JSON.parse(JSON.stringify(resp.data.data))

          const total = resp.data.total
          const perCount = resp.data.per_page
          that.totalPage = Math.ceil(total / perCount)
          if (that.totalPage === 0) {
            that.noDataText = '数据为空'
          } else {
            that.noDataText = ''
          }
        }
      })
    },

    getReBack: function () {
      this.getListData();
    },

    add: function () {
      this.$refs.tax_dom.openDialog()
    },

    gotoCurrentPage: function () {
      this.page = this.currentx
      this.getListData()
    },

    deleteData: function (id) {
      this.tr_id = id
      this.delPopUpActive = true
    },

    editData: function (row) {
      this.$refs.tax_dom.openDialog(row)
    },

    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
      return false
    },

    delConfirm: function () {
      this.btnDisabled = true

      let that = this
      setTimeout(() => {
        that.delPopUpActive = false
      }, 700)

      taxRepo.deleteRow(that.tr_id, (error, resp) => {
        that.btnDisabled = false
        if (resp.code == 0) {
          that.openNotify(resp.msg,'success')
          that.getListData()
        }
      })
    },

    closeDel: function () {
      this.delPopUpActive = false
    },
  },
}
</script>

<style lang="scss">

</style>
